module.exports = __webpack_public_path__ + "static/media/img-021.6ded18fc.png";